/**
 *
 * @param {Coordinate[]} coordinates
 *
 * @return {String} - returns
 */
export default function getCoordinatesLngLatStringList(coordinates) {
  return coordinates
    .map((coordinate) => [coordinate.lng, coordinate.lat].join(','))
    .join(';')
}